import React from "react";
import i18n from "../../../localization/i18n";
import * as rk from "../../../localization/resourceKeys";
import styles from "./header.module.scss";

const Header = () => {
  return (
    <div className="logo_container" role="banner">
      <div className={styles.logo_vwfs_wrapper}>
        <div className="logo_common logo_vwfs">
          {i18n.t(rk.LOGO_VFS_1)} {i18n.t(rk.LOGO_VFS_2)}
        </div>
        <div className="logo_common logo_vf_image">
          <img
            src="/@vwfs-bronson/bronson-vw6/dist/img/logo.svg"
            alt="VW LOGO"
            className="c-logo__image"
          />
        </div>
      </div>
      <style>{`
        .logo_container {
          display: table;
        }
        .logo_common {
          display: table-cell;
          vertical-align: middle;
        }
        .logo_vwfs {
          padding-right: 30px;
          color: rgb(0, 30, 80);
          font-family: VWHeadWeb;
          font-weight: 700;
          font-size: 18px;
        }
        .logo_vf_image {
          height: 45px !important;
          width: 30px !important;
        }
        div.logo-vf span:last-child {
          margin-top: -5px;
        }
      `}</style>
    </div>
  );
};

export default Header;
